import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
import { GraduationCap, Scale, PenTool, MapPin, Globe2, Cpu } from 'lucide-react';
export function AboutSection() {
  const {
    lang
  } = useLanguage();
  const credentials = [{
    icon: <GraduationCap className="w-5 h-5 text-inkova-lavender shrink-0" strokeWidth={1.5} data-id="element-21" />,
    text: 'Comunicadora Social · Publicidad y RRPP',
    textEn: 'Social Communicator · Advertising & PR'
  }, {
    icon: <Scale className="w-5 h-5 text-inkova-lavender shrink-0" strokeWidth={1.5} data-id="element-22" />,
    text: 'Notaria Certificada en Florida',
    textEn: 'Certified Notary in Florida'
  }, {
    icon: <PenTool className="w-5 h-5 text-inkova-lavender shrink-0" strokeWidth={1.5} data-id="element-23" />,
    text: '16 años en diseño y construcción de marcas',
    textEn: '16 years in design and brand building'
  }, {
    icon: <MapPin className="w-5 h-5 text-inkova-lavender shrink-0" strokeWidth={1.5} data-id="element-24" />,
    text: 'Establecida en Miami, Florida',
    textEn: 'Based in Miami, Florida'
  }, {
    icon: <Globe2 className="w-5 h-5 text-inkova-lavender shrink-0" strokeWidth={1.5} data-id="element-25" />,
    text: 'Sirviendo a emprendedores en cualquier parte del mundo',
    textEn: 'Serving entrepreneurs anywhere in the world'
  }, {
    icon: <Cpu className="w-5 h-5 text-inkova-lavender shrink-0" strokeWidth={1.5} data-id="element-26" />,
    text: 'AI integrada como herramienta estratégica',
    textEn: 'AI integrated as a strategic tool'
  }];
  return <section id="sobre" className="py-32 lg:py-40 bg-inkova-cream" data-id="element-27">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-28">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1fr] gap-16 lg:gap-24 items-center" data-id="element-29">
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 1,
          ease: 'easeOut'
        }} data-id="element-30">
            <div className="flex flex-col items-start gap-4 mb-8" data-id="element-31">
              <span className="block w-[40px] h-[1px] bg-inkova-primary/30" data-id="element-32" />
              <span className="inline-block font-sans text-[11px] font-semibold tracking-[3px] uppercase text-inkova-primary" data-id="element-33">
                {lang === 'es' ? 'LA FUNDADORA' : 'THE FOUNDER'}
              </span>
            </div>

            <h2 className="text-[32px] sm:text-[4vw] lg:text-[48px] font-serif text-inkova-dark leading-[1.1] tracking-[-0.5px] mb-8" data-id="element-34">
              {lang === 'es' ? <>
                  Más claridad. Más acompañamiento. Menos{' '}
                  <em className="italic text-inkova-lavender" data-id="element-35">
                    improvisación.
                  </em>
                </> : <>
                  More clarity. More accompaniment. Less{' '}
                  <em className="italic text-inkova-lavender" data-id="element-36">
                    improvisation.
                  </em>
                </>}
            </h2>

            <div className="text-[16px] lg:text-[18px] text-inkova-dark/70 font-light leading-[1.8] space-y-6 mb-12 max-w-[540px]" data-id="element-37">
              <p data-id="element-38">
                {lang === 'es' ? 'Soy Annysol Navarro — Comunicadora Social, diseñadora y Notaria Certificada en Florida con 16 años construyendo marcas, negocios y presencias digitales con propósito.' : 'I am Annysol Navarro — Social Communicator, designer, and Certified Notary in Florida with 16 years building brands, businesses, and digital presences with purpose.'}
              </p>
              <p data-id="element-39">
                {lang === 'es' ? 'Creé Inkova porque vi demasiados emprendedores con talento real perdidos en el ruido digital — sin saber cómo presentarse, cómo diferenciarse ni cómo atraer a los clientes que merecen.' : 'I created Inkova because I saw too many entrepreneurs with real talent lost in the digital noise — not knowing how to present themselves, how to differentiate themselves, or how to attract the clients they deserve.'}
              </p>
              <p data-id="element-40">
                {lang === 'es' ? 'Aquí no trabajamos con plantillas ni fórmulas genéricas. Trabajamos desde tu identidad — porque un negocio que te representa es un negocio que vende.' : "Here we don't work with templates or generic formulas. We work from your identity — because a business that represents you is a business that sells."}
              </p>

              <div className="relative pl-8 my-10" data-id="element-41">
                <div className="absolute left-0 top-0 bottom-0 w-[1px] bg-inkova-primary/30" data-id="element-42" />
                <p className="font-serif text-[20px] italic text-inkova-dark/80 leading-[1.6]" data-id="element-43">
                  {lang === 'es' ? '"Desde Miami construyo negocios digitales para emprendedores en cualquier parte del mundo — porque el talento no tiene fronteras y el propósito tampoco."' : '"From Miami I build digital businesses for entrepreneurs anywhere in the world — because talent has no borders and neither does purpose."'}
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-12" data-id="element-44">
              {credentials.map((cred, index) => <div key={index} className="flex items-center gap-4 text-[14px] text-inkova-dark/70 font-light bg-white p-4 rounded-[16px] border border-inkova-border" data-id="element-45">
                  <div className="w-[32px] h-[32px] bg-inkova-cream rounded-full flex items-center justify-center shrink-0 border border-inkova-border" data-id="element-46">
                    {cred.icon}
                  </div>
                  <span className="leading-[1.4]" data-id="element-47">
                    {lang === 'es' ? cred.text : cred.textEn}
                  </span>
                </div>)}
            </div>

            <div className="flex flex-col items-stretch sm:items-start w-full sm:w-auto" data-id="element-48">
              <a href="https://calendly.com/inkovacreation" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-inkova-lavender text-inkova-dark px-[40px] py-[18px] rounded-[18px] font-sans font-medium text-[14px] tracking-[0.5px] uppercase hover:bg-inkova-primary hover:text-white hover:shadow-[0_8px_24px_rgba(107,63,160,0.2)] hover:-translate-y-1 transition-all duration-400 w-full sm:w-auto text-center" data-id="element-49">
                {lang === 'es' ? '¿Hablamos? Da el primer paso' : 'Shall we talk? Take the first step'}
              </a>
              <span className="mt-3 text-center sm:text-left text-[12px] text-inkova-dark/50 font-sans" data-id="element-50">
                {lang === 'es' ? 'Sesión Diagnóstico · $50 · 30 minutos' : 'Diagnostic Session · $50 · 30 minutes'}
              </span>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 1.2,
          ease: 'easeOut'
        }} className="relative" data-id="element-51">
            <div className="relative overflow-hidden rounded-[32px]" data-id="element-52">
              <img src="https://cdn.magicpatterns.com/uploads/cu4jiH3V46v7kcmxVgTHZ4/annysol-sobre.jpg.png" alt="Annysol Navarro, fundadora de Inkova Creation, sosteniendo su laptop y agenda" loading="lazy" className="w-full h-[500px] lg:h-[700px] object-cover [object-position:top_center] animate-slow-zoom" data-id="element-53" />
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-transparent via-transparent to-[rgba(24,20,38,0.1)]" data-id="element-54" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}